import { isNotFoundError } from "../../utilities/errors/utils";
import { PageErrorOccurred } from "../PageErrorOccurred";
import { ProductNotFound } from "../ProductNotFound";

export interface ProductErrorGuardProps {
  error?: Error | string;
  onRetry?: () => void;
  children?: JSX.Element;
}

export function ProductErrorGuard({
  children,
  error,
  onRetry,
}: ProductErrorGuardProps) {
  if (error) {
    if (isNotFoundError(error)) {
      return <ProductNotFound />;
    }
    return (
      <PageErrorOccurred
        errorMessage={error.toString()}
        {...{ onRetry }}
      ></PageErrorOccurred>
    );
  }
  return <>{children}</>;
}
